jQuery(function(){

    jQuery('body').on('submit', '.group-travel-request-form__form', function(e){
		e.preventDefault();

		var $form = jQuery(this);

        $form.find('.group-travel-request-form__container').addClass('group-travel-request-form__container--hidden');
        $form.find('.group-travel-request-form__submission-message').removeClass('group-travel-request-form__submission-message--hidden');

		return false;
	});

});